import { SizeOption } from '../../../../types';
import { type BreedWeight } from './BreedDataset';

// picks the size with the highest probability from a BreedWeight distribution.
// kept dependency-free so both the variant selector and the quiz data layer can
// share one argmax without dragging in the sizing guide component's imports.
export function getSizeOption(item: BreedWeight): SizeOption {
  const sizes = {
    [SizeOption.XSmall]: item.XS,
    [SizeOption.Small]: item.S,
    [SizeOption.Medium]: item.M,
    [SizeOption.Large]: item.L,
    [SizeOption.XLarge]: item.XL,
  };

  const largestSize = Object.keys(sizes).reduce((a, b) => (sizes[a as SizeOption] > sizes[b as SizeOption] ? a : b));

  return largestSize as SizeOption;
}
